export default __webpack_public_path__ + "static/media/coach_guideme_softclix_lancingkit_lancets100_strips150_scale_cuff_gray@2x.d80cc3ce.webp";